import {ENDPOINT_URL} from '../constants';
import {apiErrorHandling} from '../utils/apiUtils';

const headers = new Headers();
headers.append('Content-Type', 'application/json');

export default function getChildTestType(key) {
	return fetch(`${ENDPOINT_URL}/childtesttype`, {
		method: 'POST',
		mode: 'cors',
		credentials: 'include',
		headers,
		body: JSON.stringify({
			key: key,
		}),
	})
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
